import { LocationAssociationsView } from "./associations/LocationAssociationsView";

const LocationAssociationsPage = () => <LocationAssociationsView />;

export { LocationAssociationsPage };
